import React, { useEffect, useRef, useState } from 'react';
import { Input, Label, Selectbox } from '../../css/Shared';
import { useAppContext } from '../../context/AppContext';
// import getUSPSSortation from '../../util/Sortation'; ❌ removed
import api from '../../components/Api';
import { toast } from 'react-toastify';

const ProductForm = ({ onClose, product, setProducts, setReset, reset,onCreated }) => {
  const { authState } = useAppContext();
  // const didInitSort = useRef(false); ❌ not needed

  const [formData, setFormData] = useState({
    name: '',
    height: null,
    length: '',
    thickness: '',
    weight: '',
    weightUnit: 'oz',
    isNonFlexible: false,
    isPolybagged: false,
    isUnevenThickness: false,
    hasLooseItems: false,
    // mailShape: '',
    // aspectRatio: '',
    // sortation: '',
    company: authState?.user.company,
  });

  /* ---------- EDIT LOAD ---------- */
  useEffect(() => {
    if (product) {
      const updated = {
        ...product,
        weightUnit: product.weightUnit?.toLowerCase() || 'oz',
        company: authState?.user.company,
      };

      setFormData(updated);
      // setTimeout(() => calculateSortation(updated), 0); ❌ removed
    }
  }, [product]);

const handleChange = (e) => {
  const { name, type, checked } = e.target;
  let { value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};


  const handleSubmit = async (e) => {
  e.preventDefault();

  const isUpdate = Boolean(product);

  try {
    const endpoint = product
      ? '/products/update'
      : '/products/add';

    const payload = product
      ? { ...formData, id: product._id }
      : formData;
console.log(payload)
    const res = await api.post(endpoint, payload);

    toast.success(isUpdate ? 'Product updated' : 'Product saved');

    // ✅ PRIMARY PATH (modal-controlled, JobDetailsForm)
  if (onCreated) {
  onCreated(res.data);
} else if (typeof setProducts === 'function') {
  setProducts([res.data]);   // 👈 sets current list to new product
}

    if (!onCreated && typeof setReset === 'function') {
      setReset(!reset);
    }

    onClose();
  } catch (err) {
    console.error(err.response?.data || err);
    toast.error('Failed to save product');
  }
};

console.log(formData)

  // const handleSubmit = async e => {
  //   e.preventDefault();

  //   // ❌ Sortation validation removed
  //   // if (!calculateSortation()) {
  //   //   toast.error('Invalid USPS classification');
  //   //   return;
  //   // }

  //   const payload = product
  //     ? { ...formData, id: product._id }
  //     : formData;

  //   const endpoint = product ? '/products/update' : '/products/add';

  //   await api.post(endpoint, payload);
  //   setProducts([]);
  //   toast.success(product ? 'Product updated' : 'Product saved');
  //   setReset(!reset);
  //   onClose();
  // };

  return (
    <div className="max-h-[80vh] overflow-y-auto px-6 py-5 text-[13px] text-gray-800
      [&_input]:h-9 [&_input]:text-sm [&_input]:px-3 [&_label]:text-xs">
      <form onSubmit={handleSubmit} className="space-y-6">

        <h2 className="text-sm font-medium text-gray-900">
          {product ? 'Edit Product' : 'New Product'}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2">
            <FormLabel>Product Name</FormLabel>
            <Input name="name" value={formData.name} onChange={handleChange} />
          </div>
          <div className="text-xs">
         
          </div>
        </div>

        <Section title="Dimensions">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          
            <InputGroup label="Height (in)" name="height" value={formData.height} onChange={handleChange} />
              <InputGroup label="Length (in)" name="length" value={formData.length} onChange={handleChange} />
            <InputGroup label="Thickness (in)" name="thickness" value={formData.thickness} onChange={handleChange} />
            <div>
              <FormLabel>Weight</FormLabel>
              <div className="flex gap-2">
                <Input name="weight" value={formData.weight} onChange={handleChange} />
                <Selectbox name="weightUnit" value={formData.weightUnit} onChange={handleChange}>
                  <option value="oz">oz</option>
                  <option value="lbs">lbs</option>
                </Selectbox>
              </div>
            </div>
          </div>
        </Section>

        <Section title="Special Handling">
          <div className="space-y-2">
            <Checkbox name="isNonFlexible" label="Non-Flexible" checked={formData.isNonFlexible} onChange={handleChange} />
            <Checkbox name="isPolybagged" label="Polybagged" checked={formData.isPolybagged} onChange={handleChange} />
            <Checkbox name="isUnevenThickness" label="Uneven Thickness" checked={formData.isUnevenThickness} onChange={handleChange} />
            <Checkbox name="hasLooseItems" label="Loose Items" checked={formData.hasLooseItems} onChange={handleChange} />
          </div>
        </Section>

        {/* USPS Classification section removed */}

        <div className="flex justify-end gap-3 pt-3">
          <button type="button" onClick={onClose} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" className="btn-primary">
            Save
          </button>
        </div>

      </form>
    </div>
  );
};

/* ---------- helpers (MailOwner style) ---------- */ const Section = ({ title, children }) => ( <div className="border border-gray-200 rounded-md px-4 py-3 space-y-3"> <div className="text-[11px] font-semibold text-gray-500 uppercase tracking-wide"> {title} </div> {children} </div> ); const FormLabel = ({ children }) => ( <Label className="text-[11px] font-medium text-gray-600 mb-1 block"> {children} </Label> ); const InputGroup = ({ label, name, value, onChange }) => ( <div> <FormLabel>{label}</FormLabel> <Input name={name} value={value} onChange={onChange} /> </div> ); const Checkbox = ({ name, label, checked, onChange }) => ( <label className="flex items-center gap-3 text-[13px] text-gray-700"> <input type="checkbox" name={name} checked={checked} onChange={onChange} className="h-4 w-4 rounded border-gray-300" /> <span>{label}</span> </label> );

export default ProductForm;
